module.exports = __webpack_public_path__ + "static/media/2.43979089.jpg";